__turbopack_context__.v({
  "column": "ServicesOverviewSection-module-scss-module__hfqm8G__column",
  "columnTitle": "ServicesOverviewSection-module-scss-module__hfqm8G__columnTitle",
  "container": "ServicesOverviewSection-module-scss-module__hfqm8G__container",
  "header": "ServicesOverviewSection-module-scss-module__hfqm8G__header",
  "item": "ServicesOverviewSection-module-scss-module__hfqm8G__item",
  "list": "ServicesOverviewSection-module-scss-module__hfqm8G__list",
});
